<template>
  <v-container>
    <!-- barra -->
    <v-app-bar app absolute elevation="3">
      <v-btn icon to="/">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <!-- TODO: traducir -->
      <v-toolbar-title>{{ t.app.instalar }}</v-toolbar-title>
    </v-app-bar>

    <!-- contenido -->
    <v-content class="fill-height zoom">
      <v-container class="fill-height text-center align-content-center">
        <v-row justify="center">
          <v-col class="flex-shr-ink-1 flex-grow-0 text-center">
            <v-img src="/static/png/device.png" max-width="150"></v-img>
          </v-col>
        </v-row>
        <!-- txt -->
        <v-row align-content="end" justify="center">
          <v-col class="pb-0">
            <h2>Lo sentimos</h2>
            <p>
              Su navegador no es compatible,<br />le sugerimos utilizar o
              actualizar<br />
              <strong>Google Chrome</strong>
            </p>
          </v-col>
        </v-row>
        <!-- img btns -->
        <v-row align-content="start" justify="center">
          <v-container class="py-0">
            <v-row align="center" justify="center">
              <v-col class="flex-shr-ink-1 flex-grow-0 px-2">
                <v-img src="/static/svg/googlechrome.svg" max-width="48" />
              </v-col>
              <!-- apple -->
              <v-col
                v-show="deviceInfo === 'ambos' || deviceInfo === 'Apple'"
                class="flex-shr-ink-1 flex-grow-0 px-2"
              >
                <v-btn
                  class="pl-2"
                  href="https://apps.apple.com/co/app/google-chrome/id535886823"
                  target="_blank"
                >
                  <v-avatar size="24" class="mr-2">
                    <v-img src="/static/png/apple.png"></v-img>
                  </v-avatar>
                  Apple
                </v-btn>
              </v-col>
              <!-- android -->
              <v-col
                class="flex-shr-ink-1 flex-grow-0 px-2"
                v-show="deviceInfo === 'ambos' || deviceInfo === 'PlayStore'"
              >
                <v-btn
                  class="pl-2"
                  href="https://play.google.com/store/apps/details?id=com.android.chrome"
                  target="_blank"
                >
                  <v-avatar size="24" class="mr-2">
                    <v-img src="/static/png/google.png"></v-img>
                  </v-avatar>
                  PlayStore
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-content>
  </v-container>
</template>

<script>
// https://www.freepik.es/fotos-vectores-gratis/negocios

export default {
  name: "mdd-instalar",
  computed: {
    deviceInfo() {
      let ua = navigator.userAgent;

      if (ua.indexOf("Android") > 0) return "PlayStore";
      if (ua.indexOf("iPhone") > 0) return "Apple";
      if (ua.indexOf("iPod") > 0) return "Apple";
      if (ua.indexOf("iPad") > 0) return "Apple";

      return "ambos";
    },
    isMobile() {
      let ua = navigator.userAgent;
      return (
        ua.indexOf("Android") > 0 ||
        ua.indexOf("iPhone") > 0 ||
        ua.indexOf("webOS") > 0 ||
        ua.indexOf("iPod") > 0 ||
        ua.indexOf("iPad") > 0 ||
        ua.indexOf("BlackBerry") > 0
      );
    },
    browserPwaCompatible() {
      return "onbeforeinstallprompt" in window;
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  }
};
</script>
